//Importaciones
import React, { useContext } from 'react'
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import ListTemplate from '../../../../../Templates/List';
import { Card, Col, Row } from 'react-bootstrap';
import { Icon, IconButton, TooltipHost } from '@fluentui/react';
import './style.css'
import MainAppContext from '../../../../../../MainAppContext';
import i18next from 'i18next';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import ChangeComponentType from '../Dataserie/ChangeComponentType';
import { __enum_ChartDataserieInputType, enum__ComponentType, enum__ComponentType_InvertedEnum, enum__KPIAgregationTypes } from '../../../../../../common/Dictionaries';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { action_setBoardChartContainerIdSelected, action_setBoardDataseries, action_setBoardViewComponentInfoRecursiveValues, action_setEvents, action_updateBoardFullStructure, action_updateChartSelectedDatapoint, action_updateComponentInfoData, action_updateComponentInfoDataChartCompare, action_updateComponentInfoDataCompare } from '../../../../../../reducers/actions/KPI/actions';
import { updateBoardCompoenet } from '../../../../../../services/sKPI/board.service';
import { getBoardVariableDataSerieValues } from '../../../../../../services/sKPI/dataserie.service';
import { getLocalStorageValue } from '../../../../../../common/Helpers';
import { BOARD_AGGREGATION_WHEN_NULL, BOARD_AGRUPATION_WHEN_NULL } from '../../../../../../configurations/application.config';
import SidePanelViewDataserieAditionalInfo from '../../BoardBox/BoardListNew/SidePanelViewDataserieAditionalInfo';
import SidePanelDeleteDataserieVariableValue from '../../BoardBox/BoardListNew/SidePanelDeleteDataserieVariableValue';
import SidePanelEditDataserieVariableValue from '../../BoardBox/BoardListNew/SidePanelEditDataserieVariableValue';
import SidePanelAddDataserieVariableValue from '../../BoardBox/BoardListNew/SidePanelAddDataserieVariableValue';
import BoardAppContext from '../../../../../../BoardAppContext';

function ELEMENT_KPI_SCOPE_DUMMY(props) {
    //Helpers
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);

    const [aggregationDataseries, setAggregationDataseries] = useState(getLocalStorageValue('PARAM_COOKIE_DATASERIES_AGGREGATED_DUMMY', BOARD_AGGREGATION_WHEN_NULL));

    const [data, setData] = useState(__OBJECT_STRUCTURE_GetList(15, 
        [
            {
            variableName: 'KPI',
            l_agg_vals: [
                {
                    beginDate: '01/01/2024',
                    dataserieId: 0,
                    elementId: 0,
                    elementName: "0000000 | Contrato",
                    color: "na",
                    desv: 0,
                    desvPercent: 0,
                    displayValue: 0,
                    id: 0,
                    serieTime: 0,
                    serieTimeDT: null,
                    serieTimeStr: null,
                    v1: 0,
                    v2: 0,
                    valueGoal: 0,
                    valueGoalPercent: 0,
                    visibleFront: false
                }
            ],
            l_vals: [
                {
                    beginDate: '01/01/2024',
                    dataserieId: 0,
                    elementId: 0,
                    elementName: "0000000 | Contrato",
                    color: "na",
                    desv: 0,
                    desvPercent: 0,
                    displayValue: 0,
                    id: 0,
                    serieTime: 0,
                    serieTimeDT: null,
                    serieTimeStr: null,
                    v1: 0,
                    v2: 0,
                    valueGoal: 0,
                    valueGoalPercent: 0,
                    visibleFront: false
                }
            ]
        }]
    ));

    const fieldCount = contextSite.kpiModule.boardDataserieDisplayFields.value.map(({ field }) => field).length
    
    const getMainFieldWidth = (count) => {
        switch (count) {
            case 1:
                return 175
                break;
            case 2:
                return 190
                break;
            case 3:
                return 280
                break;
            case 4:
                return 400
                break;
            default:
                return 0
                break;
        }
    }

    //Render de componente.
    return (
                <Row className='text-center px-1'>
                    <Col>
                    {
                        <ListTemplate
                            manipulateLocalData={ true }
                            className={"display-none no-compact-list " + (aggregationDataseries === 1 ? "kpilist" : "")}
                            showHeaders={false}
                            isHeaderVisible={false}
                            listLocalStoragePageSizeVariableName="messageTree"
                            data={ (data.data !== null ? data : []) }
                            setData={ setData }
                            inputParam_Styles={{root: { zIndex: -2, minHeight: "30px" }}}
                            columns={ (data.data !== null) ? [
                                {
                                    key: 'variableName',
                                    name: t('data-lang-lbl-name'),
                                    fieldName: 'variableName',
                                    minWidth: 250,
                                    maxWidth: 250,
                                    onRender:(item) => {
                                        const fields = contextSite.kpiModule.boardDataserieDisplayFields.value.map(({ field }) => field);
                                        const inputParam_Index = data.data.indexOf(item)
                                        
                                        return  <div className={` w-100`} style={{height: aggregationDataseries === 1 ? "29px" : undefined, overflow: "auto hidden"}}>
                                                    <Row className="mx-0 border h-100" style={{width: ((4 * 141) + getMainFieldWidth(fieldCount - 4)) +"px"}}>
                                                        <Col className='w-100'>
                                                            <Row>
                                                                <Col style={{minWidth: "100px", height: "100%"}} className={`border-start border-end w-auto px-0 h-100`}>
                                                                    {
                                                                        (inputParam_Index === 0) &&
                                                                        <div style={{fontSize: "1rem"}} className="border-bottom h-100">
                                                                            <Col className="text-center h-100"><b style={{fontSize: "14px"}}>{ t(`data-lang-lbl-name`) }</b></Col>
                                                                        </div>
                                                                    }
                                                                    <div style={{fontSize: "12px", borderLeft: `10px solid`}} className={`my-0 px-1 h-100 pt-1`}>
                                                                        <TooltipHost content={item.variableName}>
                                                                            <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                                {item.variableName}
                                                                            </div>
                                                                        </TooltipHost>
                                                                    </div>
                                                                </Col>
                                                                {
                                                                    fields.map((field, index) => (
                                                                        <Col style={{minWidth: (index === 0) ? "100px" : "85px", height: "100%"}} className={
                                                                            `col-auto border-start border-end px-0 ${(fields.length !== index)? "px-0" : "ps-2" }`
                                                                            } key={index}>
                                                                            {
                                                                                (inputParam_Index === 0) &&
                                                                                <div style={{fontSize: "1rem"}} className="border-bottom">
                                                                                    <Col className="text-center"><b style={{fontSize: "14px"}}>{ t(`data-lang-lbl-field-${field}`) }</b></Col>
                                                                                </div>
                                                                            }
                                                                            {
                                                                                contextSite.kpiModule.boardCalendarFilterConfig.value.displayAgregationId === enum__KPIAgregationTypes.NO_AGG && 
                                                                                <>
                                                                                    {
                                                                                        item.l_vals.map((val, index) => (
                                                                                            <div style={{fontSize: "12px"}} key={index} className={`${index} h-100 pt-1 ${(index !== item.l_vals.length -1) ? 'border-bottom' : ''} my-0 pe-1 ${field.toLowerCase().indexOf('percent') !== -1 || field.toLowerCase().indexOf('time') !== -1 ? "text-center" : "text-end" } ${field.toLowerCase() === 'valuereal' || field.toLowerCase() === 'displayvalue' ? "variable-text-color-" + val.color : "variable-value-color" } ${field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color-" + val.color : "" } `}>
                                                                                                {          
                                                                                                    field === "serieTime" &&
                                                                                                    <>
                                                                                                        {val["serieTimeStr"] !== null ? val["serieTimeStr"].toString() : val["serieTime"]}
                                                                                                    </>
                                                                                                }
                                                                                                {
                                                                                                    field !== "serieTime" &&
                                                                                                    <>
                                                                                                        {`${val[field] !== undefined && val[field] !== null && !isNaN(val[field]) ? (field !== 'serieTime' ? parseFloat(val[field]).toLocaleString(i18next.language) : val[field])  : t('no-data')}`}
                                                                                                        {`${field.toLowerCase().indexOf('percent') !== -1 ? " %" : ""}`}
                                                                                                    </>
                                                                                                }
                                                                                            </div>
                                                                                        ))
                                                                                    }
                                                                                    {
                                                                                        item.l_vals.length === 0 && 
                                                                                            <div style={{fontSize: "12px"}} className={`my-0 px-1 ${field.toLowerCase().indexOf('percent') !== -1 || field.toLowerCase().indexOf('time') !== -1 ? "text-center" : "text-end" } ${field.toLowerCase() === 'valuereal' || field.toLowerCase() === 'displayvalue' ? "variable-value-color" : "variable-value-color" } ${field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color" : "" } `}>{t('no-data')}</div>
                                                                                    }
                                                                                </>
                                                                            }
                                                                            {
                                                                                contextSite.kpiModule.boardCalendarFilterConfig.value.displayAgregationId === enum__KPIAgregationTypes.DF_AGG && 
                                                                                <>
                                                                                    {
                                                                                        item.l_agg_vals.map((val, index) => (
                                                                                            <div style={{fontSize: "12px"}} key={index} className={`${index} h-100 pt-1 ${(index !== item.l_agg_vals.length -1) ? 'border-bottom' : ''} my-0 pe-1 ${field.toLowerCase().indexOf('percent') !== -1 || field.toLowerCase().indexOf('time') !== -1 ? "text-center" : "text-end" } ${field.toLowerCase() === 'valuereal' || field.toLowerCase() === 'displayvalue' ? "variable-text-color-" + val.color : "variable-value-color" } ${field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color-" + val.color : "" } `}>
                                                                                                {          
                                                                                                    field === "serieTime" &&
                                                                                                    <>
                                                                                                        {val["serieTimeStr"] !== null ? val["serieTimeStr"].toString() : val["serieTime"]}
                                                                                                    </>
                                                                                                }
                                                                                                {
                                                                                                    field !== "serieTime" &&
                                                                                                    <>
                                                                                                        {`${val[field] !== undefined && val[field] !== null && !isNaN(val[field]) ? (field !== 'serieTime' ? parseFloat(val[field]).toLocaleString(i18next.language) : val[field])  : t('no-data')}`}
                                                                                                        {`${field.toLowerCase().indexOf('percent') !== -1 ? " %" : ""}`}
                                                                                                    </>
                                                                                                }
                                                                                            </div>
                                                                                        ))
                                                                                    }
                                                                                    {
                                                                                        item.l_agg_vals.length === 0 && 
                                                                                            <div style={{fontSize: "12px"}} className={`my-0 px-1 ${field.toLowerCase().indexOf('percent') !== -1 || field.toLowerCase().indexOf('time') !== -1 ? "text-center" : "text-end" } ${field.toLowerCase() === 'valuereal' || field.toLowerCase() === 'displayvalue' ? "variable-value-color" : "variable-value-color" } ${field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color" : "" } `}>{t('no-data')}</div>
                                                                                    }
                                                                                </>
                                                                            }
                                                                        </Col>
                                                                    ))
                                                                }
                                                            </Row>
                                                        </Col>
                                                        <Col className='col-auto ms-auto' style={{
                                                            position: 'sticky',
                                                            right: -4,
                                                            backgroundColor: 'white',
                                                            zIndex: '1',
                                                        }}>
                                                            <Row>
                                                                
                                                            </Row>
                                                        </Col>
                                                    
                                                    </Row>
                                                    
                                                </div>
                                    }
                                }                
                            ] : [] }
                            enableExport={ false }
                        />
                    }  
                    </Col>
                </Row>
            );
}

export default ELEMENT_KPI_SCOPE_DUMMY;